export enum TrackingEvent {
  ReplaysPreviewClicked = `ReplaysPreviewClicked`,
  ReplaysPreviewLoaded = `ReplaysPreviewLoaded`,
  ReplaysPreviewNoReplays = `ReplaysPreviewNoReplays`,
  ReplaysPreviewError = `ReplaysPreviewError`,
}

export type TrackingProperties = {
  FetchTimeMs?: number;
  LoadTimeMs?: number;
  TotalTimeMs?: number;
  EventName?: string;
};

export const track = (event: TrackingEvent, properties: TrackingProperties = {}) => {
  mixpanel.track(event, properties);
};
